import { observer } from 'mobx-react';
import React from 'react';
import { branchStore } from 'src/mobx/barnchStore';
import { cartStore } from 'src/mobx/cartStore';
import { localeStore } from 'src/mobx/localesStore';
import { formatPrice } from 'src/utils/formatter';
import './style.scss';

const CartInfoPopup = observer((): JSX.Element | null => {
  if (!cartStore.calculator.left_to_min_order && !cartStore.calculator.left_to_free_delivery) return null;

  return (
    <div className={'d-flex flex-column card cart-info-popup'}>
      {/* if left left_to_min_order is presend and more of zero need to show this message  */}
      {cartStore.calculator.left_to_min_order ? (
        <p className="family-semibold text-size-14 color color-gray text-center">
          {localeStore.t('minimum_order_alert_message')} {formatPrice(cartStore.calculator.min_order)}
        </p>
      ) : null}

      {/* if left left_for_free_delivery is presend and more of zero need to show this message  */}
      {cartStore.calculator.left_to_free_delivery ? (
        <p className="family-semibold text-size-14 color color-gray text-center">
          {formatPrice(cartStore.calculator.left_to_free_delivery)} {localeStore.t('left_for_free_delivery')}
        </p>
      ) : null}
    </div>
  );
});

export default React.memo(CartInfoPopup);
